document.addEventListener("DOMContentLoaded", function() {

  /* ===== MORPHING TEXT ===== */
  document.querySelectorAll("[data-morphing-words]").forEach(function(el) {
    var words = el.getAttribute("data-morphing-words").split(",").filter(Boolean);
    var speed = parseInt(el.getAttribute("data-morph-speed") || "2500", 10);
    var idx = 0;

    setInterval(function() {
      el.classList.add("fade-out");
      setTimeout(function() {
        idx = (idx + 1) % words.length;
        el.textContent = words[idx];
        el.classList.remove("fade-out");
      }, 400);
    }, speed);
  });

  /* ===== RATING BARS ===== */
  document.querySelectorAll("[data-rating-bars]").forEach(function(container) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          container.querySelectorAll("[data-bar-target]").forEach(function(bar) {
            bar.style.width = bar.getAttribute("data-bar-target") + "%";
          });
          observer.unobserve(container);
        }
      });
    }, { threshold: 0.3 });

    observer.observe(container);
  });

  /* ===== PROGRESS LINE ===== */
  document.querySelectorAll("[data-progress-line]").forEach(function(el) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          el.classList.add("animated");
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.3 });

    observer.observe(el);
  });


});
/* ===== IMAGE TEXT REVEAL ===== */
document.querySelectorAll("[data-reveal]").forEach(function(el) {
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        el.classList.add("revealed");
        observer.unobserve(el);
      }
    });
  }, { threshold: 0.2 });

  observer.observe(el);
});


/* ===== HERO V2 EFFECTS ===== */
document.querySelectorAll("[data-hero]").forEach(function(hero) {

  // Fade + slide on load
  setTimeout(function() {
    hero.classList.add("loaded");
  }, 200);

  // Optional parallax effect
  window.addEventListener("scroll", function() {
    var scroll = window.scrollY;
    var bg = hero.querySelector("[data-hero-bg]");

    if (bg) {
      bg.style.transform = "translateY(" + (scroll * 0.3) + "px)";
    }
  });

});